module.exports = __webpack_public_path__ + "static/media/dont-miss-the-party.7fd9366f.png";